// hooks/billing/useOrgQuotas.js
import { useCallback, useEffect, useState } from 'react';
import BillingService from '../../services/billing.service';

/**
 * useOrgQuotas — `GET /organizations/{orgId}/quotas`.
 *
 * Returns `items` (array of QuotaPolicyItem). Read-only — the upsert
 * route is documented in schemas but not wired in backend today.
 *
 * @param {string} organizationId
 * @param {Object} [options]
 * @param {boolean} [options.auto=true]
 */
export function useOrgQuotas(organizationId, { auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(auto && organizationId));
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!organizationId) return;
    setLoading(true);
    setError(null);
    const result = await BillingService.listOrgQuotas(organizationId);
    if (result.success) {
      setData(result.data?.items ?? []);
    } else {
      setError(result);
    }
    setLoading(false);
  }, [organizationId]);

  useEffect(() => {
    if (auto && organizationId) {
      refetch();
    } else if (!organizationId) {
      setData(null);
      setError(null);
      setLoading(false);
    }
  }, [auto, organizationId, refetch]);

  return { data, loading, error, refetch };
}

export default useOrgQuotas;
